import { graphql } from "@/lib/gql/__generated__";

export const RESERVATION_DETAIL_UPDATE_NO_SHOW_STATUS_FOR_MANAGEMENT_RESERVATION_ITEM_DETAIL_UPDATE_MUTATION = graphql(
	/* GraphQL */ `
		mutation ReservationDetailUpdateNoShowStatusForManagementReservationItemDetailUpdate(
			$input: ReservationDetailUpdateNoShowStatusInput!
		) {
			reservationDetailUpdateNoShowStatus(input: $input) {
				reservationDetail {
					statusNoShow
					canCancel
				}
				userErrors
			}
		}
	`,
);
